export default class KeyboardMenu {
    constructor({
        maxLength = 15,
        targetDisplayText = '',
        output = '',
        uppercase = true,
        characterLimit = 16,
    }) {
        this.maxLength = maxLength;
        this.targetDisplayText = targetDisplayText;
        this.output = output;
        this.uppercase = uppercase;
        this.characterLimit = characterLimit;
        this.uppercaseOptions = [
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '\u00A0', '!', '?', '/'],
            ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', '\u00A0', '\u2642', '\u2640', '-'],
            ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', '\u00A0', '\u00A0', '“', '”', '…'],
            ['Z', 'X', 'C', 'V', 'B', 'N', 'M', ',', '.', '\u00A0', '\u00A0', '‘', '’', '\u00A0'],
        ];
        this.lowercaseOptions = [
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '\u00A0', '!', '?', '/'],
            ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '\u00A0', '\u2642', '\u2640', '-'],
            ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '\u00A0', '\u00A0', '“', '”', '…'],
            ['z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '\u00A0', '\u00A0', '‘', '’', '\u00A0'],
        ];
        this.currentOption = {
            x: 0,
            y: 0,
        };
        this.targetType = 'player';
    }

    increaseHorizontalOption() {
        this.currentOption.x = (this.currentOption.x + 1) % 14;
    }

    increaseVerticalOption() {
        this.currentOption.y = (this.currentOption.y + 1) % 4;
    }

    decreaseHorizontalOption() {
        if (this.currentOption.x === 0) {
            this.currentOption.x = 13;
        } else {
            this.currentOption.x = (this.currentOption.x - 1) % 14;
        }
    }

    decreaseVerticalOption() {
        if (this.currentOption.y === 0) {
            this.currentOption.y = 3;
        } else {
            this.currentOption.y = (this.currentOption.y - 1) % 4;
        }
    }

    currentChar() {
        const uppercaseOption = this.uppercaseOptions[this.currentOption.y][this.currentOption.x];
        const lowercaseOption = this.lowercaseOptions[this.currentOption.y][this.currentOption.x];
        return this.uppercase ? uppercaseOption : lowercaseOption;
    }

    selectCurrentChar() {
        const currentChar = this.currentChar();
        if (this.output.length < this.characterLimit) {
            this.output += currentChar;
        }
        return this.output;
    }

    deleteLastChar() {
        if (this.output.length > 0) {
            this.output = this.output.substring(0, this.output.length - 1);
            return this.output;
        }
    }
}
